import { Component, Injector } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { BaseView } from '../base-view';

@Component({
  templateUrl: './confirmation-dialog.component.html'
})
export class ConfirmationDialogComponent extends BaseView {

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    protected _injector: Injector) {
      super(_injector)
  }

  showCancel: boolean;
  title: string;
  message: string;
}
